// Difficulty in bits. Difficulty (expected hashes per proof) = 2^256 / (target + 1), so
// log2(difficulty) is the number of leading zero bits a hash needs, to within a fraction of a
// bit. A hash's own "bits" are 256 - log2(hash + 1).

/** log2 of a positive bigint, with ~1e-12 precision for large values */
export function log2Big(x: bigint): number {
  if (x <= 0n) return -Infinity;
  const len = x.toString(2).length;
  if (len <= 53) return Math.log2(Number(x));
  const shift = BigInt(len - 53);
  return Math.log2(Number(x >> shift)) + (len - 53);
}

/** log2(expected hashes) for a target */
export const targetBits = (target: bigint) => 256 - log2Big(target + 1n);

/** leading-zero "bits" of a 32-byte hash: 256 - log2(hash + 1) */
export const hashBits = (hash: string | bigint) => 256 - log2Big((typeof hash === 'bigint' ? hash : BigInt(hash)) + 1n);

/** whole leading zero bits of a 32-byte hash */
export function leadingZeroBits(hash: string | bigint): number {
  const h = typeof hash === 'bigint' ? hash : BigInt(hash);
  return h === 0n ? 256 : 256 - h.toString(2).length;
}

/** log2 of a difficulty given as a float (expected hashes) */
export const difficultyBits = (d: number) => (d > 0 && Number.isFinite(d) ? Math.log2(d) : 0);

/** "38.4" */
export const fmtBits = (b: number, digits = 1) => (Number.isFinite(b) ? b.toFixed(digits) : '—');
